import React, { useState } from "react";
import { FormattedMessage } from "react-intl";

import { useStatus } from "@/api/statuses";
import QuotedStatus from "@/components/quoted-status";
import Tombstone from "@/components/tombstone";
import { Button } from "@/components/ui";

interface QuotedStatusContainerProps {
  /** Status ID to the quoted status. */
  statusId: string;
  source?: string | undefined;
  avatarSize?: number;
}

const QuotedStatusContainer: React.FC<QuotedStatusContainerProps> = ({
  statusId,
  source,
  avatarSize,
}) => {
  const { isLoading, status } = useStatus(statusId);
  const [isTombstoned, setIsTombstoned] = useState(
    status?.tombstone !== undefined,
  );

  if (!status || isLoading) {
    return null;
  }

  if (isTombstoned) {
    return (
      <Tombstone
        id={status.id}
        type={status.tombstone?.reason}
        action={
          status.tombstone?.reason === "muted" ? (
            <Button
              type="button"
              variant="link"
              className="p-0!"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                setIsTombstoned(false);
              }}
            >
              <FormattedMessage id="common.view" defaultMessage="View" />
            </Button>
          ) : undefined
        }
      />
    );
  }

  return (
    <QuotedStatus status={status} source={source} avatarSize={avatarSize} />
  );
};

export default QuotedStatusContainer;
